enum ProfileType {
  CUSTOMER = "customer",
  DRIVER = "driver",
  CIF_DRIVER = "cif_driver",
  CARRIER = "carrier",
}

export default ProfileType;
